import { createContext, useContext } from 'react';

import type { Locale } from '../i18n';

export type ToastType = 'default' | 'success' | 'error';

export interface AppContextValue {
  api: <T>(path: string, init?: RequestInit) => Promise<T>;
  bgm: <T>(path: string, init?: RequestInit) => Promise<T>;
  bgmAuth: <T>(path: string, init?: RequestInit) => Promise<T>;
  checkBangumiToken: () => Promise<void>;
  locale: Locale;
  changeLocale: (locale: Locale) => void;
  navigate: (path: string, replace?: boolean) => void;
  showToast: (message: string, type?: ToastType) => void;
}

export const AppContext = createContext<AppContextValue | undefined>(undefined);

export const useApp = (): AppContextValue => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('AppContext is not available');
  }
  return context;
};
